import { useMemo, useSyncExternalStore } from "react";
import type { WorkshopId } from "../../../../api/workshop";
import { getLiveStore, type LiveView } from "../liveStore";

/**
 * Subscribe to a workshop's classroom-management live state (pause + teacher
 * message, plus the message's local shown/collapsed UI flag), mirrored from the
 * SSE stream. The underlying connection is shared across all callers for the
 * same workshop and closes when the last one unmounts.
 */
export const useLiveState = (workshopId: WorkshopId): LiveView => {
  const store = useMemo(() => getLiveStore(workshopId), [workshopId]);
  return useSyncExternalStore(store.subscribe, store.getState);
};
